export default "__VITE_ASSET__50d22985__"